import { useContext } from 'react';

import InventoryAssetTreeTransfer from '@atom/components/common/inventoryAssetTreeTransfer/InventoryAssetTreeTransfer';
import ReplaceElementModalContext from '@atom/components/common/replaceElement/ReplaceElementModalContext';
import {
  CategoryPathItem,
  InventoryAssetDetailType,
  SearchAssetWithElements,
} from '@atom/types/inventory';

import classes from './replaceElement.module.css';

interface Props {
  handleDestinationAssetClick: (
    asset: InventoryAssetDetailType | SearchAssetWithElements,
    path: CategoryPathItem[],
  ) => void;
}

const DestinationStep = ({ handleDestinationAssetClick }: Props) => {
  const { element, rootAsset, parentSchemaId } = useContext(
    ReplaceElementModalContext,
  );

  return (
    <div className={classes.listContainer}>
      <div className={classes.stepContentHeader}>
        <span>Where should</span>
        <span className={classes.bold}>{`"${element?.name}"`}</span>
        <span>on</span>
        <span className={classes.bold}>{`"${rootAsset?.name}"`}</span>
        <span>be moved after being replaced?</span>
      </div>
      <InventoryAssetTreeTransfer
        filterParams={{
          schemaId: rootAsset?.schemaId,
          elementSchemaId: parentSchemaId,
        }}
        onAssetClick={handleDestinationAssetClick}
        removeAssetId={rootAsset?.id}
      />
    </div>
  );
};

export default DestinationStep;
